export default "__VITE_ASSET__B53SNz2w__";